import styleText from './as-panel-header.css?raw';

export class AsPanelHeader extends HTMLElement {
  static readonly tag = 'as-panel-header' as const;

  private static readonly _sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = /*html*/`
      <div class="panel-header">
        <slot></slot>
      </div>
    `;
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsPanelHeader._sheet
    ];
  } 
  connectedCallback() {
    
  }
}

customElements.define(AsPanelHeader.tag, AsPanelHeader);  
